import React, { createContext, useContext, useState } from "react";
const SingleFlightContextProvider = createContext();

export const SelectedOptionsProvider = ({ children }) => {
const [progressPercentage, setProgressPercentage] = useState(0); 
const [flightPositionData, setFlightPositionData] = useState([]);
const [currentIndex, setCurrentIndex] = useState(0);
const [distanceCovered, setDistanceCovered] = useState(0);

  return (
    <SingleFlightContextProvider.Provider
      value={{
        progressPercentage,setProgressPercentage,
        flightPositionData, setFlightPositionData,
        currentIndex, setCurrentIndex,
        distanceCovered, setDistanceCovered
      }}
    >
      {children}
    </SingleFlightContextProvider.Provider>
  );
};

export const useSelectedOptions = () => {
  const context = useContext(SingleFlightContextProvider);
  if (context === undefined) {
    throw new Error("useSelectedOptions must be used within a SelectedOptionsProvider");
  }
  return context;
};
